import React, { Component } from 'react'

import SideBarButton from './SideBarButton';

import './Ranking.css'

export default class App extends Component {

    constructor(props){
        super(props);

        this.state = {
            mapRanking: true
        }
    }

    _mapRanking = (ball, index) => {
        const currentPlayer = ball.id === this.props.clientId
        const className = currentPlayer ? "ranking-current" : null
        const liFull = <li key={"rank-"+ball.rank} className={className}>{`${ball.rank}: ${ball.player.name} (${(ball.time/1000).toFixed(1)})`}</li> 
        const liPart = <li key={"rank-"+ball.rank} className={className}>{`${ball.rank}: ${(ball.time/1000).toFixed(1)}`}</li>
        if(ball.break){
            return [
                <li key={"rank-dots"} className="ranking-dots"></li>,
                this.props.fullRanking ? liFull : liPart
            ]
        }else{
            return this.props.fullRanking ? liFull : liPart
        }
    }

    _mapPartRanking = (ball, index) => {
        const currentPlayer = ball.id === this.props.clientId
        const className = currentPlayer ? "ranking-current" : null
        
        if(ball.break){
            return [
                <li key={"rank-dots"} className="ranking-dots"></li>,
                <li key={"rank-"+ball.rank} className={className}>{`${ball.rank}: ${(ball.time/1000).toFixed(1)}`}</li>
            ]
        }else{
            return <li key={"rank-"+ball.rank} className={className}>{`${ball.rank}: ${(ball.time/1000).toFixed(1)}`}</li>
        }
    }

    _filterRanking = (ranking) => {
        // create an array with the leaders and the players close to the current player
        const currentPlayerIndex = ranking.findIndex( ball => ball.id === this.props.clientId)
        const numRanks = ranking.length
        let filteredRanking = []
        let currentRank = 1
        ranking.forEach( (ball, index) => {
            if((currentPlayerIndex > 6 && index < 6) || (currentPlayerIndex <= 7 && index < 10)){
                // if the player is in the top 6 get 10 ranks,
                // otherwise get the first 6 and continue with the ranks around the current player ones
                const rank = index+1
                currentRank = rank
                filteredRanking.push({
                    rank,
                    ...ball
                })
            } else if(numRanks-currentPlayerIndex-1 !== 0 && index >= currentPlayerIndex-1 && index <= currentPlayerIndex+1){
                // player is somewhere in the middle of the ranking, get one before and one after the current player
                const rank = index+1
                filteredRanking.push({
                    rank,
                    break: rank - currentRank > 1, // there is a break in the ranking, insert dots
                    ...ball
                })
                currentRank = rank
            } else if(numRanks-currentPlayerIndex-1 === 0 && index >= currentPlayerIndex-2){
                // player is in last place, get two before the current player
                const rank = index+1
                filteredRanking.push({
                    rank,
                    break: rank - currentRank > 1, // there is a break in the ranking, insert dots
                    ...ball
                })
                currentRank = rank
            }
        })
        return filteredRanking
    }

    componentDidUpdate(prevProps){
        if(prevProps.collapsed !== this.props.collapsed){
            if(this.props.collapsed === "fullyCollapsed" || this.props.collapsed === "partlyCollapsed"){
                setTimeout( () => this.setState({mapRanking: false}), 300) // remove the mapping of the ranking after a short delay for better performance
            }else{
                this.setState({mapRanking: true})
            }
        }
    }

    render(){
        const fullRanking = this.props.fullRanking
        const boxExtraClass = fullRanking ? "ranking-box-full" : "ranking-box-part"
        const fullyCollapsed = this.props.collapsed === "fullyCollapsed"
        const partlyCollapsed = this.props.collapsed === "partlyCollapsed"
        const rankingLoaded = this.props.currentRanking.length > 0
        const fullContentHeight = fullyCollapsed 
            ? 0 
            : partlyCollapsed 
                ? 42
                : 235 // hardcoded pixel values as 'auto' can't be translated :/
        const boxHeight = partlyCollapsed ? 0 : 195

        return (
            <div className={"ranking-wrapper"+(fullyCollapsed?" collapsed":"")} style={{height: fullContentHeight}}>
                <SideBarButton 
                    fullText="Ranking" 
                    smallText="Rank" 
                    handleButtonClick={this.props.toggleRanking} 
                    fullButton={fullRanking} 
                    collapsed={this.props.collapsed} 
                />
                <div className={"ranking-box "+boxExtraClass+(partlyCollapsed?" collapsed":"")} style={{height: boxHeight}}>
                    <div className="ranking-content">
                        {
                            rankingLoaded && this.state.mapRanking
                                ? <ul className="ranking-ul">
                                    { this._filterRanking(this.props.currentRanking).map( (ball, index) => this._mapRanking(ball,index))}
                                </ul>
                                : "..."
                        }
                    </div>
                </div>
            </div>
        )
    }
}